function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SwitchField } from '@dhis2-ui/switch';
import PropTypes from 'prop-types';
import React from 'react';
import { createToggleChangeHandler, createFocusHandler, createBlurHandler, hasError, isValid, getValidationText } from '../shared/helpers.js';
import { metaPropType, inputPropType } from '../shared/propTypes.js';
export const SwitchFieldFF = _ref => {
  let {
    error,
    input,
    meta,
    showValidStatus,
    valid,
    validationText,
    onBlur,
    onFocus,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(SwitchField, _extends({}, rest, {
    checked: input.checked,
    name: input.name,
    value: input.value,
    error: hasError(meta, error),
    valid: isValid(meta, valid, showValidStatus),
    validationText: getValidationText(meta, validationText, error),
    onFocus: createFocusHandler(input, onFocus),
    onChange: createToggleChangeHandler(input),
    onBlur: createBlurHandler(input, onBlur)
  }));
};
SwitchFieldFF.propTypes = {
  /** `input` props received from Final Form `Field` */
  input: inputPropType.isRequired,
  /** `meta` props received from Final Form `Field` */
  meta: metaPropType.isRequired,
  error: PropTypes.bool,
  showValidStatus: PropTypes.bool,
  valid: PropTypes.bool,
  validationText: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func
};